import * as React from 'react';
import Navbar from './Navbar';

interface IHeaderProps {
  showNavbar?: boolean;
}

export default function Header(props: IHeaderProps) {
  const { showNavbar = false } = props;

  return (
    <header className="container-fluid shadow-none">
      <div className="row">
        <div className="col-12 justify-content-center align-items-center header--inner d-flex">
          <a href="//www.segurosfalabella.com/cl/" target="_blank" rel="noopener noreferrer">
            <img src="https://sfestaticos.blob.core.windows.net/pmc/salud/assets/svg/salud-complementario/logo_sf.svg" alt="Logo Seguros Falabella" width="200px" />
          </a>
        </div>
      </div>
      {showNavbar && <Navbar />}
    </header>
  );
}
